<template>
    <div>
        <h2 class="text-body font-semibold text-black first-letter:uppercase mb-16">
            {{ $t('jobs.create.headers.description_social_media') }}
        </h2>

        <translatable #default="{ languages, selectedLanguage }" :errors="warningTabs">
            <div v-for="lang in languages" :key="lang">
                <simple-input
                    v-show="lang === selectedLanguage"
                    v-model="form.og_title[lang]"
                    class="mb-8"
                    :input-label="$t('jobs.og_title') + (languages.length > 1 ? ' (' + lang + ')' : '')"
                />

                <text-area
                    v-show="lang === selectedLanguage"
                    v-model="form.og_description[lang]"
                    class="w-full"
                    :input-label="$t('jobs.og_description') + (languages.length > 1 ? ' (' + lang + ')' : '')"
                />
            </div>
        </translatable>

        <div class="w-full mt-16">
            <label class="mb-4 text-body-sm  text-black flex items-center">
                <span class="first-letter:uppercase font-semibold">{{ $t('jobs.og_image') }}</span>
            </label>
            <siu
                v-model="form.og_image_queued_id"
                :image="image"
                classes="h-240 rounded"
                icon-location="corner"
            ></siu>
        </div>
    </div>
</template>

<script>
import SelectDropdown from './forms/SelectDropdown';
import Input from './forms/Input';
import Form from '../etc/forms/Form';
import Loading from './ui/Loading';
import SimpleButton from './ui/SimpleButton';
import Checkbox from './forms/Checkbox';
import Translatable from './forms/Translatable';
import TextArea from './forms/TextArea';
import SingleImageUpload from './forms/SingleImageUpload';
import {mapStores} from "pinia";
import {useMainStore} from "../state/store";


export default {
    components: {
        TextArea,
        Translatable,
        Checkbox,
        SimpleButton,
        Loading,
        'simple-input': Input,
        SelectDropdown,
        'siu': SingleImageUpload,
    },
    props: {
        value: Form,
        image: String,
    },
    computed: {
        ...mapStores(useMainStore),
        currentCompany() {
            return this.mainStore.currentCompany;
        },
        warningTabs() {
            let languages = this.currentCompany.jobsite.active_languages;
            let errorLang = [];

            for (let index in languages) {
                if (!this.form.data.og_title[languages[index]]) {
                    errorLang.push(languages[index]);
                }
                if (!this.form.data.og_description[languages[index]]) {
                    errorLang.push(languages[index]);
                }
            }
            return errorLang;
        },
        form: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
};
</script>
